export default "/icon-nav-saved.svg";